import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { useForm } from "react-hook-form";
import { IInvoiceTracking } from "./Form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InputText } from "primereact/inputtext";
import { json } from "stream/consumers";

interface IProps {
    tableData: [],
    open: boolean,
    hideDialoge: () => void,
    toast: any
}

interface formSchema {
    total_Recived_Amount: number,
    paymentStatus: string,
    payment_Mode: string,
    transaction_ID: string,
}

const schema = yup.object({
    total_Recived_Amount: yup.number().required("Total Recived Amount is Required"),
    payment_Mode: yup.string().required("Payment Mode is Required"),
    transaction_ID: yup.string().required("Transaction ID is Required"),
});

export const MultiInvoiceStatusUpdate = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: props.tableData, loading: false } as { tableData: IInvoiceTracking[], loading: boolean });
    const [totalInviceAmount, setTotalInviceAmount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [showTable, setShowTable] = useState<boolean>(false);
    const [showAllInvoicePaymentStatus, setShowAllInvoicePaymentStatus] = useState<boolean>(false);
    const [allInvoicePaymentStatus, setAllInvoicePaymentStatus] = useState<string | null>(null);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<formSchema>({
        resolver: yupResolver(schema),
        //defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onHide = () => {
        setTotalInviceAmount(0);
        setShowTable(false);
        props.hideDialoge();
    }

    const onSubmitBulk = async (data: formSchema) => {
        let sumOfRecived_Amount = 0;
        tableData.tableData.forEach((e: any) => {
            sumOfRecived_Amount = sumOfRecived_Amount + Number(e.receivedAmount);
        });

        if (showTable === false && Number(data.total_Recived_Amount) !== totalInviceAmount) {
            setShowTable(true);
        } else {
            console.log(sumOfRecived_Amount, data.total_Recived_Amount);
            if (sumOfRecived_Amount !== data.total_Recived_Amount) {
                props.toast.current.show({ severity: 'error', detail: 'Total Invoice Amount is not equals to Total Recived Amount.', life: 3000 });
            } else {
                setLoading(true);
                let bulkData: IInvoiceTracking[] = [];
                let paymentStatus = "";
                if (Number(data.total_Recived_Amount) === totalInviceAmount) {
                    paymentStatus = "Paid";
                } else if (Number(data.total_Recived_Amount) < totalInviceAmount) {
                    paymentStatus = "Balance";
                } else if (Number(data.total_Recived_Amount) > totalInviceAmount) {
                    paymentStatus = "Over Payment";
                } else {
                    paymentStatus = "Pending";
                };

                if (Number(data.total_Recived_Amount) === totalInviceAmount) {
                    bulkData = tableData.tableData.map((invoice: IInvoiceTracking) => ({
                        invoice_ID: invoice.invoice_ID,
                        paymentStatus: paymentStatus,
                        receivedAmount: invoice.invoiceAmount,
                        payment_Mode: data.payment_Mode,
                        transaction_ID: data.transaction_ID,
                    }));
                } else {
                    bulkData = tableData.tableData.map((invoice: IInvoiceTracking) => ({
                        invoice_ID: invoice.invoice_ID,
                        paymentStatus: invoice.paymentStatus,
                        receivedAmount: invoice.receivedAmount,
                        payment_Mode: data.payment_Mode,
                        transaction_ID: data.transaction_ID,
                    }));
                }

                // const response = await Fetch("InvoiceTracking/updateBulkPaymentStatus", "PUT", bulkData, encodeURIComponent(JSON.stringify(`paymentMode=${data.payment_Mode}&transaction=${data.transaction_ID}`)), props.toast);
                const response = await Fetch("InvoiceTracking/updateBulkPaymentStatus", "PUT", bulkData, `paymentMode=${data.payment_Mode}&transaction=${encodeURIComponent(data.transaction_ID)}`, props.toast);

                if (response) {
                    props.toast.current.show({ severity: 'success', detail: 'Invoices updated successfully.', life: 3000 });
                    onHide();
                }
                setLoading(false);
            }
        }

    };

    // const Payment_Status = [
    //     { name: "-- SELECT --", value: null },
    //     { name: "Pending", value: "Pending" },
    //     { name: "Paid", value: "Paid" },
    //     { name: "Balance", value: "Balance" },
    //     { name: "Over Payment", value: "Over Payment" },
    // ];
    const Payment_Mode = [
        { name: "-- SELECT --", value: null },
        { name: "Cheque", value: "CHEQUE" },
        { name: "NetBanking", value: "NET BANKING" },
        { name: "UPI", value: "UPI" },
        { name: "PayPal", value: "PAYPAL" },
    ];

    const getPaymentStatus = (invoiceAmount: number, recivedAmount: number) => {
        if (`${invoiceAmount}`.trim() === `${recivedAmount}`.trim()) {
            return "Paid";
        } else if (invoiceAmount > recivedAmount) {
            return "Balance";
        } else if (invoiceAmount < recivedAmount) {
            return "Over Payment";
        } else {
            return "Pending";
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "total_Recived_Amount") {
                if (value.total_Recived_Amount != null && value.total_Recived_Amount != undefined && Number(value.total_Recived_Amount) != 0) {
                    if (Number(value.total_Recived_Amount) === totalInviceAmount) {
                        setShowAllInvoicePaymentStatus(prev => prev = true);
                        setAllInvoicePaymentStatus(prev => prev = "Paid");
                    } else if (Number(value.total_Recived_Amount) < totalInviceAmount) {
                        setShowAllInvoicePaymentStatus(prev => prev = true);
                        setAllInvoicePaymentStatus(prev => prev = "Balance");
                    } else if (Number(value.total_Recived_Amount) > totalInviceAmount) {
                        setShowAllInvoicePaymentStatus(prev => prev = true);
                        setAllInvoicePaymentStatus(prev => prev = "Over Payment");
                    } else {
                        setShowAllInvoicePaymentStatus(prev => prev = false);
                        setAllInvoicePaymentStatus(prev => prev = "");
                    }
                }
            }
        });
        return () => subscription.unsubscribe();

    }, [watch, totalInviceAmount]);

    useEffect(() => {

        if (props.open) {
            setTableData({ tableData: props.tableData, loading: false });
            let sum = 0;
            props.tableData.forEach((e: any) => {
                if (e.paymentStatus !== "Paid") {
                    setShowTable(prev => prev = true);
                }
                sum = sum + Number(e.invoiceAmount);
            });
            setTotalInviceAmount(sum);
        };
    }, [props.open]);

    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.open} onHide={() => onHide()} header="Bulk Update Payment Status" >
                <form onSubmit={handleSubmit(onSubmitBulk)} className="p-fluid formgrid grid" >
                    <div className='field col-12 md:col-4'>
                        <label>Total Invoice Amount</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{totalInviceAmount}</p>
                    </div>
                    <JVInput required column={3} label="Total Recived Amount" control={control} name="total_Recived_Amount" error={errors.total_Recived_Amount?.message} />
                    {showAllInvoicePaymentStatus && <div className='field col-12 md:col-4'>
                        <label>Payment Status</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{allInvoicePaymentStatus}</p>
                    </div>}
                    <JVDropdown column={3} label="Payment Mode" control={control} name="payment_Mode" options={Payment_Mode} optionLabel="name" optionValue="value" placeholder="Select Payment Mode" error={errors.payment_Mode?.message} />
                    <JVInput required column={3} label="Transaction ID" control={control} name="transaction_ID" error={errors.transaction_ID?.message} />
                    <Button label="Update" type="submit" loading={loading} />
                </form>

                {showTable && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "25px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    // selection={selectedBenchs}
                    // onSelectionChange={(e) => setSelectedBenchs(e.value)}
                    selectionMode="multiple"
                    dataKey="invoice_ID"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 20]}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="invoiceNO" header="Invoice#" />
                    <Column field="invoiceAmount" header="Amout" />
                    <Column header="Recived Amout" body={(rowData: IInvoiceTracking, options) => {
                        return <InputText placeholder={"Enter Received Amount"} value={rowData.receivedAmount || ''} type="number" onChange={(e: any) => {
                            let newTableData = tableData.tableData;
                            newTableData[options.rowIndex].receivedAmount = e.target.value;
                            newTableData[options.rowIndex].paymentStatus = getPaymentStatus(newTableData[options.rowIndex]?.invoiceAmount || 0, e.target.value);
                            setTableData({ tableData: newTableData, loading: false });
                        }} />
                    }} />
                    <Column field="paymentStatus" header="Payment Status" />
                </DataTable>}
            </Dialog>
        </>
    );
}